import "intl-tel-input/build/js/intlTelInput-jquery";

$(document).ready(function() {
  var phoneInput = $('.phone-number-input');

  phoneInput.intlTelInput({
    initialCountry: 'FR',
    preferredCountries: ['FR'],
    separateDialCode: true,
    formatOnDisplay: true,
    autoHideDialCode: false,
    nationalMode: false,
    hiddenInput: 'phone_number',
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@22.0.2/build/js/utils.js',
  });

  phoneInput.closest('form').on('submit', function(e) {
    if (phoneInput.intlTelInput('isValidNumber') &&
        [
          intlTelInputUtils.numberType.MOBILE,
          intlTelInputUtils.numberType.FIXED_LINE,
          intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE,
        ].includes(phoneInput.intlTelInput('getNumberType'))) {
      phoneInput.val(phoneInput.intlTelInput('getNumber'));
    } 
  });
});
